import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import JobList from '../components/Jobs/JobList';
import JobListLayout from '../components/Jobs/JobList/JobListLayout';
import withQuery from '../lib/withQuery';
import citiesQuery from '../lib/queries/jobs/citiesQuery.graphql';
import withApollo from '../lib/apollo';
import { useSiteContext } from '../components/SiteContext';
import messages from '../lib/messages.json';
import LoadMore from '../components/LoadMore';
import loadMore from '../lib/queries/loadMore';

const JobsCitiesList = ({
  data, loading, fetchMore, variables,
}) => {
  const { citiesConnection: { edges, pageInfo: { hasNextPage } } } = data;
  const intl = useIntl();

  return (
    <>
      <JobList
        listData={edges.map(
          ({ node: { name, slug, jobsCount } }) => ({
            name,
            slug,
            jobsCount,
          }),
        )}
        labelKey="jobs-cities.jobs"
        nameKey="city"
        labelHeading={intl.formatMessage(messages.city)}
        paramKey="citySlug"
      />
      <LoadMore
        loading={loading}
        hasNextPage={hasNextPage}
        fetchMore={
          () => loadMore({
            variables,
          })(data, 'citiesConnection', fetchMore)
        }
      />
    </>
  );
};

JobsCitiesList.propTypes = {
  data: PropTypes.shape({
    citiesConnection: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({}),
      ),
      pageInfo: PropTypes.shape({
        hasNextPage: PropTypes.bool,
      }),
    }),
  }),
  variables: PropTypes.shape({}).isRequired,
  fetchMore: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

JobsCitiesList.defaultProps = {
  data: {},
};

const JobsCitiesListWithQuery = withQuery(JobsCitiesList);

const JobCities = () => {
  const intl = useIntl();
  const { jobsLocale } = useSiteContext();

  return (
    <JobListLayout
      breadcrumbLabel={intl.formatMessage(messages.cities)}
      listPrefix="jobs-cities"
    >
      <JobsCitiesListWithQuery
        query={citiesQuery}
        variables={{ locales: [jobsLocale], first: 10 }}
        errorMessage="Could not load jobs by city"
      />
    </JobListLayout>
  );
};

export default withApollo(JobCities);
